exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slide-leave-active[data-v-7566b5b7],\n.slide-enter-active[data-v-7566b5b7] {\n  -webkit-transition: 1s;\n  transition: 1s;\n}\n.slide-enter[data-v-7566b5b7] {\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.slide-leave-to[data-v-7566b5b7] {\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.img-slider[data-v-7566b5b7]{\n  overflow: hidden;\n  position: relative;\n  height: 200px;\n  width: 400px;\n}\n.img-slider img[data-v-7566b5b7] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right:0;\n}\n", ""]);

// exports
